window.MemberHealthEmail = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            messages: {
                invalidEmail: '#invalid-email',
                invalidConfirmEmail: '#invalid-confirm-email'
            },
            textBox: {
                memberEmail: '#member-form-email-input',
                confirmEmail: '#member-form-confirm-email-input'
            },
            labels: {
                confirmEmailLabel: 'label[for="member-form-confirm-email-input"]',
            },
        },
        urls: {
            sendFormDataUrl: '/api/sitecore/UpdateContactDetails/UpdateHealthEmail',
            cleanPlanNumberSessionUrl: '/api/sitecore/MyAccount/CleanPlanNumberSession',
            personalDetailsPageUrl: '/my-account/details',
            errorPageUrl: '/error/error-page'
        },
        constants: {
            NoUpdateMessageCode: 'NoUpdate'
        },
        statusDescription: {
            accepted: 'accepted'
        },
        css: {
            vdsHiddenItem: 'vds-item-hidden'
        },
        originalEmail: '',
        func: {
            init: function () {
                self.func.bindings();
                $(self.elements.messages.invalidEmail).addClass(self.css.vdsHiddenItem);

                self.originalEmail = $(self.elements.textBox.memberEmail).val();

                $(self.elements.textBox.memberEmail).on('input', function () {
                    const currentEmail = $(this).val();
                    if ((currentEmail !== self.originalEmail) || (self.originalEmail === '' || !self.originalEmail)) {
                        self.func.showConfirmEmail();
                    } else {
                        self.func.hideConfirmEmail();
                    }
                });

                    },
            bindings: function () {
                $('#member-form').on('submit', self.func.handleSaveMemberEmail);
            },
            validateEmail: function (email) {
                const emailRegex = /^(?!\.)(?!.*\.\.)([^\s@.]{1,64}|[^\s@.][^\s@]{0,62}[^\s@.])@(?!(?:\.|\.\.))([^\s@.]+(?:\.[^\s@.]+)+)$/;

                const maxLocalPartLength = 64;
                const maxDomainLength = 255;

                const emailParts = email.split('@');
                const isValidFormat = emailRegex.test(email);

                const isValidLength = emailParts.length === 2 &&
                    emailParts[0].length <= maxLocalPartLength &&
                    emailParts[1].length <= maxDomainLength;

                return isValidFormat && isValidLength;
            },
            showConfirmEmail: function () {
                $(self.elements.textBox.confirmEmail).removeClass(self.css.vdsHiddenItem);
                $(self.elements.labels.confirmEmailLabel).removeClass(self.css.vdsHiddenItem);
            },
            hideConfirmEmail: function () {
                $(self.elements.textBox.confirmEmail).addClass(self.css.vdsHiddenItem);
                $(self.elements.labels.confirmEmailLabel).addClass(self.css.vdsHiddenItem);
                $(self.elements.messages.invalidConfirmEmail).addClass(self.css.vdsHiddenItem);
            },
            handleSaveMemberEmail: function (event) {
                event.preventDefault()
                $(self.elements.messages.invalidEmail).addClass(self.css.vdsHiddenItem);
                $(self.elements.messages.invalidConfirmEmail).addClass(self.css.vdsHiddenItem);

                const memberEmail = $(self.elements.textBox.memberEmail).val();
                const confirmEmail = $(self.elements.textBox.confirmEmail).val();

                if (!self.func.validateEmail(memberEmail)) {
                    $(self.elements.messages.invalidEmail).removeClass(self.css.vdsHiddenItem);
                } else if (((confirmEmail !== memberEmail) && (self.originalEmail !== memberEmail)) || (
                    ( (self.originalEmail) || self.originalEmail !== '') && memberEmail === '')
                ) {
                    $(self.elements.messages.invalidConfirmEmail).removeClass(self.css.vdsHiddenItem);
                } else {
                    $.ajax({
                        type: 'POST',
                        url: self.urls.sendFormDataUrl,
                        data: {
                            email: memberEmail
                        },
                        success: function(response) {
                            if (response.statusCode.toLowerCase() === self.statusDescription.accepted) {
                                window.location.href = self.urls.personalDetailsPageUrl;
                            }
                            else {
                                window.location.href = self.urls.errorPageUrl;
                            }
                        },
                        error: function() {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    });
                }
            },
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('memberHealthEmail' === $('#member-form').data('feature')) {
        window.MemberHealthEmail.Init();
    }
});
